import React, {PureComponent} from 'react'
import PropTypes from 'prop-types'
import {ButtonDropdown, DropdownItem, DropdownMenu, DropdownToggle} from 'reactstrap'
import {Link} from 'react-router-dom'

class DriverActionsCell extends PureComponent {
  state = {
    isOpen: false,
  };

  toggle = () => this.setState({isOpen: !this.state.isOpen});

  render() {
    const driverId = this.props.driverId;
    return (
      <ButtonDropdown isOpen={this.state.isOpen} toggle={this.toggle}>
        <DropdownToggle color="link" size="sm" caret>
          mais
        </DropdownToggle>
        <DropdownMenu>
          <DropdownItem header>Sobre</DropdownItem>
          <DropdownItem tag={Link} to={`/maetoristas/${driverId}/editar`}>Editar mãetorista</DropdownItem>
          <DropdownItem divider />
          <DropdownItem header>Mais informações</DropdownItem>
          <DropdownItem tag={Link} to={`/maetoristas/${driverId}/familias`}>Famílias/Crianças</DropdownItem>
          <DropdownItem tag={Link} to={`/maetoristas/${driverId}/pagamentos`}>Pagamentos</DropdownItem>
        </DropdownMenu>
      </ButtonDropdown>
    )
  }
}

DriverActionsCell.propTypes = {
  driverId: PropTypes.string.isRequired,
};

const styles = {};

export default DriverActionsCell;



// WEBPACK FOOTER //
// ./src/components/DriverActionsCell.js